module.exports = __webpack_public_path__ + "static/media/stats.5267dc6a.png";